import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex-brightworld/icons';
import { Container } from '@codex-brightworld/basics';

const Spinner = styled(Icon).attrs({ icon: 'loading', spin: true })`
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  color: ${props => props.theme.colors.shades[4]};
`;

const AvailabilityLocation = styled.span`
  font-weight: bold;
  color: ${props => props.theme.colors.shades[2]};
`;

const AvailabilityList = styled.ul`
  display: flex;
  margin: 5px 0 0;
  padding: 0;
`;

const AvailabilityItem = styled.li`
  display: flex;
  align-items: flex-start;
  flex: 1 0 50%;
  margin: 0;
  padding: 0 10px 0 0;
  list-style: none;
`;

const ItemIcon = styled(Icon)`
  min-width: 22px;
  width: 22px;
  height: 22px;
  margin: -4px 2px 4px -3px;
  color: ${props => (props.positive ? props.theme.colors.positive.default : 'inherit')}
`;

function ProductAvailability(props) {
  if (!props.delivery.label && !props.collection.label) {
    return <noscript />;
  }

  const items = [];

  if (props.delivery.label) {
    items.push(props.delivery);
  }

  if (props.collection.label) {
    items.push(props.collection);
  }

  return (
    <Container
      data-component="ProductAvailability"
      className={props.className}
      data-qa={props.qa}
      color="purple"
    >
      {props.inProgress && (
        <Spinner />
      )}

      {!props.inProgress && (
        <>
          {props.locationLabel} <AvailabilityLocation>{props.location}</AvailabilityLocation>

          <AvailabilityList>
            {items.map(item => (
              <AvailabilityItem key={item.label}>
                <ItemIcon icon={item.available ? 'notifications' : 'close'} positive={item.available} />{' '}
                <span dangerouslySetInnerHTML={{ __html: item.label }} />
              </AvailabilityItem>
            ))}
          </AvailabilityList>
        </>
      )}
    </Container>
  );
}

ProductAvailability.propTypes = {
  className: PropTypes.string,
  collection: PropTypes.shape({
    available: PropTypes.bool,
    label: PropTypes.string
  }),
  delivery: PropTypes.shape({
    available: PropTypes.bool,
    label: PropTypes.string
  }),
  inProgress: PropTypes.bool,
  location: PropTypes.string.isRequired,
  locationLabel: PropTypes.string,
  qa: PropTypes.string
};

ProductAvailability.defaultProps = {
  className: '',
  collection: {},
  delivery: {},
  inProgress: false,
  locationLabel: 'For',
  qa: undefined
};

export default ProductAvailability;
